import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Box } from '@/components/blocks/Box';
import { Flex } from '@/components/blocks/Flex';
import { Icon } from '@/components/blocks/Icon';
import { Text } from '@/components/blocks/Text';
import { theme } from '@/styles/theme';

const Root = styled(Flex)(() =>
  css({
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    padding: theme.spaces.l,
    textAlign: 'center',
  })
);

const IconBox = styled(Box)({
  width: 40,
  height: 40,
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto',
});

export const NotFound = () => {
  return (
    <Root>
      <IconBox>
        <Icon icon='alert' />
      </IconBox>
      <Box marginTop={theme.spaces.xl}>
        <Text use='l-B' block>
          ページが見つかりません
        </Text>
      </Box>
      <Box marginTop={theme.spaces.xl}>
        <Text use='s-N' block>
          お探しのページは一時的にアクセスできない状況にあるか、移動もしくは削除された可能性があります。
          <br />
          アプリケーションを終了して、再度お試しください。
        </Text>
      </Box>
    </Root>
  );
};
